module.exports = __webpack_public_path__ + "static/media/RightArrow.d46914e6.svg";